var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsuFileDattente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350.4 407.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.2,13.4c-13.1,0-23.8,10.6-23.8,23.8s10.6,23.8,23.8,23.8v8.2c0,31.5,12.6,61.7,34.8,84l50.4,50.4-50.4,50.4c-22.3,22.3-34.8,52.5-34.8,84v8.2c-13.1,0-23.8,10.6-23.8,23.8s10.6,23.8,23.8,23.8h237.7c13.1,0,23.8-10.6,23.8-23.8s-10.6-23.8-23.8-23.8v-8.2c0-31.5-12.6-61.7-34.8-84l-50.4-50.4,50.4-50.4c22.3-22.3,34.8-52.5,34.8-84v-8.2c13.1,0,23.8-10.6,23.8-23.8s-10.6-23.8-23.8-23.8H59.2ZM249.4,338.1v8.2H106.8v-8.2c0-18.9,7.5-37.1,20.9-50.4l50.4-50.4,50.4,50.4c13.4,13.4,20.9,31.5,20.9,50.4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsuFileDattente);
export default __webpack_public_path__ + "static/media/asu_file_dattente.b913b741f5c58bffe755758226d0fadf.svg";
export { ForwardRef as ReactComponent };